// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IModelResponse, IModel } from '@cian/http-api';
import type { IGetAgentInfoResponseV3Schema } from '../../entities/agent_info/GetAgentInfoResponseV3Schema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetAgentInfoRequest {
  /** Циан ID пользователя **/
  cianUserId: number;
  /** Тип аккаунта **/
  accountType: EAccountType;
}
export enum EAccountType {
  /** Агентство **/
  'Agency' = 'agency',
  /** Специалист **/
  'Specialist' = 'specialist',
}

export type IGetAgentInfoResponse = IGetAgentInfoResponseV3Schema;

export interface IGetAgentInfoResponse200 extends IModelResponse<IGetAgentInfoResponse> {
  statusCode: 200;
}

export type IGetAgentInfoResponseError = IErrorResponseSchema;

export interface IGetAgentInfoResponse400 extends IModelResponse<IGetAgentInfoResponseError> {
  statusCode: 400;
}

export type TGetAgentInfoResponse = IGetAgentInfoResponse200 | IGetAgentInfoResponse400;

export type TGetAgentInfoModel = IModel<IGetAgentInfoRequest, TGetAgentInfoResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetAgentInfoResponse): TResponse200;
  400(response: IGetAgentInfoResponseError): TResponse400;
}
